export default __webpack_public_path__ + "static/media/hook.84e323f5.svg";